import { postSecureAccountsApi, putAccountsApi, deleteAccountsApi, getSecureAccountsApi, getMainApi, postMainApi, putMainApi, deleteMainApi } from "@Shared/utils/ajax";
import { omit, pick } from "lodash";
export const saveAutomation = async automation => {
  if (automation.id) {
    await putAccountsApi({
      automation: omit(automation, ["id"])
    }, `/customize/automation/${automation.id}`);
  } else {
    await postSecureAccountsApi({
      automation: omit(automation, ["id"])
    }, "/customize/automation");
  }
};
export const deleteAutomation = async id => {
  await deleteAccountsApi(`/customize/automation/${id}`);
};
export const getAutomation = async (type = "board") => {
  return getSecureAccountsApi({
    type
  }, "/customize/automation");
};
export const getDocumentRequestRules = async () => {
  return getMainApi({}, "/document-request-rule");
};
export const createDocumentRequestRule = async documentRequestRule => {
  return postMainApi({
    documentRequestRule
  }, "/document-request-rule");
};
export const updatedDocumentRequestRule = async (documentRequestRuleId, {
  documentRequestRule,
  active,
  title,
  description
}) => {
  const payload = {
    documentRequestRule: pick(documentRequestRule, ["documents", "rules", "booleanMode", "applicantMode"]),
    active,
    title,
    description
  };
  return putMainApi(payload, `/document-request-rule/${documentRequestRuleId}`);
};
export const deleteDocumentRequestRule = async documentRequestRuleId => {
  return deleteMainApi({}, `/document-request-rule/${documentRequestRuleId}`);
};